var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumGw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FFF0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5904 14.41L13.3104 24.69C12.8304 25.17 12.0104 25.06 11.7204 24.45C11.2004 23.38 10.9004 22.17 10.9004 20.9C10.8804 15.38 16.4804 10.66 18.3804 9.21C18.7504 8.93 19.2504 8.93 19.6104 9.21C20.4804 9.87 22.1104 11.24 23.6404 13.04C23.9804 13.44 23.9604 14.04 23.5904 14.41Z",
    fill: "#E13153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 20.91C27.1 25.37 23.47 29 19 29C17.21 29 15.54 28.42 14.19 27.42C13.7 27.06 13.66 26.34 14.09 25.91L24.16 15.84C24.63 15.37 25.42 15.47 25.74 16.05C26.56 17.56 27.11 19.2 27.1 20.91Z",
    fill: "#E13153"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumGw);
export default __webpack_public_path__ + "static/media/hum-gw.b0d96d1ced8ffa0ee3fc1eec942ce672.svg";
export { ForwardRef as ReactComponent };